import { render, staticRenderFns } from "./SmediasList.vue?vue&type=template&id=c5800c16"
import script from "./SmediasList.vue?vue&type=script&lang=js"
export * from "./SmediasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports